import _extends from "reshow-runtime/es/helpers/extends";
import _slicedToArray from "reshow-runtime/es/helpers/slicedToArray";
import _objectWithoutProperties from "reshow-runtime/es/helpers/objectWithoutProperties";
import React, { useRef, useState, useEffect, useMemo } from "react";
import callfunc from "call-func";
import Animate from "../organisms/Animate";

var Change = function Change(props) {
  var propsChildren = props.children,
      onExited = props.onExited,
      onEntered = props.onEntered,
      keyEqualer = props.keyEqualer,
      otherProps = _objectWithoutProperties(props, ["children", "onExited", "onEntered", "keyEqualer"]);

  var _useState = useState(propsChildren),
      _useState2 = _slicedToArray(_useState, 2),
      children = _useState2[0],
      setChildren = _useState2[1];

  var mount = useRef(false);
  var nextChildren = useRef(propsChildren);
  var isRunning = useRef(false);
  var nextCall = useRef(false);

  var handleExited = function handleExited(node, isAppear) {
    if (mount.current && nextChildren.current) {
      setChildren(nextChildren.current);
      callfunc(onExited, [node, isAppear]);
    }
  };

  var handleEntered = function handleEntered(node, isAppear) {
    isRunning.current = false;

    if (nextCall.current) {
      callfunc(nextCall.current);
    }

    setTimeout(function () {
      return mount.current && callfunc(onEntered, [node, isAppear]);
    });
  };

  useEffect(function () {
    mount.current = true;

    var setNext = function setNext(willChild) {
      var reset = function reset() {
        nextCall.current = function () {
          return setNext(willChild);
        };
      };

      if (nextChildren.current !== willChild && !keyEqualer(children, willChild)) {
        if (willChild && !isRunning.current) {
          nextChildren.current = willChild;
          nextCall.current = false;
          children ? setChildren(null) : setChildren(willChild);
          isRunning.current = true;
        } else {
          reset();
        }
      } else {
        reset();
      }
    };

    setNext(propsChildren);
    return function () {
      mount.current = false;
    };
  }, [propsChildren]);
  return useMemo(function () {
    return /*#__PURE__*/React.createElement(Animate, _extends({}, otherProps, {
      onExited: handleExited,
      onEntered: handleEntered
    }), children);
  }, [children]);
};

Change.defaultProps = {
  unmountOnExit: false,
  keyEqualer: function keyEqualer(item1, item2) {
    return (item1 === null || item1 === void 0 ? void 0 : item1.key) === (item2 === null || item2 === void 0 ? void 0 : item2.key);
  }
};
export default Change;